const setupProgress = (state = {}, action) => {
  const { type, uuid, ...props } = action
  if (type === 'SET_SETUP_PROGRESS') {
    return { ...state, [uuid]: { ...state[uuid], ...props, uuid } }
  }
  return state
}
export default setupProgress
